module.exports = "/_next/static/images/2aad6efe18f41cae411be910c26cdd24-xpeer-lg.jpg.webp";